import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    private loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    LoaderStatus: Observable<boolean> = this.loaderSubject.asObservable();

    ShowLoader(){
        this.loaderSubject.next(true);
    }

    HideLoader(){
        this.loaderSubject.next(false);
    }

    ngOnDestroy() {
        this.loaderSubject.complete();
      }

      
}